import React from 'react';
import { ClassAssembly4C2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly4C2026/>;
  };
  
  export default ClassAssemblyPage;